<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :title="workshop.id ? '编辑' : '新建'"
    width="1200px"
    top="5vh"
    @close="resetForm"
  >
    <el-form ref="form" :model="workshop" :rules="ruleValidate" label-width="140px" label-suffix=" :">
      <div class="fm-section-title">编码标识</div>
      <el-row :gutter="10">
        <el-col v-if="workshop.id" :span="6">
          <el-form-item label="车间编码">
            <el-input v-model="workshop.workshopCode" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="车间全称" prop="workshopName">
            <el-input v-model="workshop.workshopName" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="车间简称">
            <el-input v-model="workshop.workshopShortName" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="英文名称">
            <el-input v-model="workshop.workshopEnglishName" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="ERP编码">
            <el-input v-model="workshop.workshopERPCode" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="WMS编码">
            <el-input v-model="workshop.workshopWMSCode" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="WCS编码">
            <el-input v-model="workshop.workshopWCSCode" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="SCADA编码">
            <el-input v-model="workshop.workshopSCADACode" />
          </el-form-item>
        </el-col>
      </el-row>

      <div class="fm-section-title">类型与分类</div>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="所属工厂" prop="factoryID">
            <el-input v-model="factoryName" placeholder="请选择所属工厂" readonly>
              <el-button slot="append" icon="el-icon-search" @click="$refs.factorySelect.open()"></el-button>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="车间类型" prop="workshopType">
            <el-select v-model="workshop.workshopType" clearable>
              <el-option v-for="item in workshopTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="细分工艺">
            <el-select v-model="workshop.workshopSubType" clearable>
              <el-option v-for="item in workshopSubTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="车间状态" prop="workshopStatus">
            <el-select v-model="workshop.workshopStatus" clearable>
              <el-option v-for="item in workshopStatusOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="是否试制车间">
            <el-radio-group v-model="workshop.isTrialWorkshop">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="是否外协车间">
            <el-radio-group v-model="workshop.isOutsourceWorkshop">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <div class="fm-section-title">环境与面积</div>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="是否洁净车间">
            <el-radio-group v-model="workshop.isCleanRoom">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="洁净等级">
            <el-select v-model="workshop.cleanRoomLevel" clearable>
              <el-option v-for="item in cleanRoomLevelOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="标准温度(℃)">
            <el-input-number v-model="workshop.standardTemp" :min="-50" :max="100" controls-position="right" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="标准湿度(%RH)">
            <el-input-number v-model="workshop.standardHumidity" :min="0" :max="100" controls-position="right" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="粉尘管控">
            <el-radio-group v-model="workshop.dustControl">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="ESD防静电">
            <el-radio-group v-model="workshop.staticControl">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="总面积(㎡)">
            <el-input-number v-model="workshop.totalArea" :min="0" controls-position="right" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="生产区面积(㎡)">
            <el-input-number v-model="workshop.productionArea" :min="0" controls-position="right" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="仓储区面积(㎡)">
            <el-input-number v-model="workshop.storageArea" :min="0" controls-position="right" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="物流通道面积(㎡)">
            <el-input-number v-model="workshop.passageArea" :min="0" controls-position="right" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="设备区面积(㎡)">
            <el-input-number v-model="workshop.equipmentArea" :min="0" controls-position="right" />
          </el-form-item>
        </el-col>
      </el-row>

      <div class="fm-section-title">人员与管理</div>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="车间主管">
            <el-input v-model="workshop.supervisorName" placeholder="请输入车间主管姓名" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="生产经理">
            <el-input v-model="workshop.productionMgrName" placeholder="请输入生产经理姓名" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="质量经理">
            <el-input v-model="workshop.qualityMgrName" placeholder="请输入质量经理姓名" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="维修主管">
            <el-input v-model="workshop.maintainerName" placeholder="请输入维修主管姓名" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="安全管理员">
            <el-input v-model="workshop.safetyMgrName" placeholder="请输入安全管理员姓名" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="最大容纳人数">
            <el-input-number v-model="workshop.maxStaffCount" :min="0" controls-position="right" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="标准定员">
            <el-input-number v-model="workshop.standardStaffCount" :min="0" controls-position="right" />
          </el-form-item>
        </el-col>
      </el-row>

      <div class="fm-section-title">质量管控</div>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="是否关键车间">
            <el-radio-group v-model="workshop.isKeyWorkshop">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="首件检验">
            <el-radio-group v-model="workshop.needFirstArticleCheck">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="过程巡检IPQC">
            <el-radio-group v-model="workshop.needIPQC">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="完工终检OQC">
            <el-radio-group v-model="workshop.needOQC">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="追溯等级">
            <el-select v-model="workshop.traceLevel" clearable>
              <el-option v-for="item in traceLevelOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <div class="fm-section-title">备注</div>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="车间备注">
            <el-input v-model="workshop.remark" type="textarea" :rows="2" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="扩展字段">
            <el-input v-model="workshop.extendJson" type="textarea" :rows="2" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <CommonSelect
      ref="factorySelect"
      title="选择工厂"
      url="fm/factory-manger"
      :columns="factoryColumns"
      :search-items="factorySearchItems"
      :filter="factoryFilter"
      @select="selectFactory"
    />

    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="submitHandle">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import CommonSelect from "../CommonSelect";

export default {
  components: { CommonSelect },
  data() {
    return {
      dialogVisible: false,
      submitLoading: false,
      factoryName: "",
      factoryFilter: {
        factoryCode: "",
        factoryName: "",
      },
      factorySearchItems: [
        { key: "factoryCode", label: "工厂编码", placeholder: "请输入工厂编码" },
        { key: "factoryName", label: "工厂全称", placeholder: "请输入工厂全称" },
      ],
      factoryColumns: [
        { title: "工厂编码", key: "factoryCode", width: 120, align: "center" },
        { title: "工厂全称", key: "factoryName" },
        { title: "工厂简称", key: "factoryShortName", width: 120 },
        { title: "操作", slot: "action", width: 80, align: "center" },
      ],
      workshopTypeOptions: [
        { label: "生产", value: 1 },
        { label: "仓储", value: 2 },
        { label: "质检", value: 3 },
        { label: "辅助", value: 4 },
        { label: "试制", value: 5 },
      ],
      workshopSubTypeOptions: [
        { label: "SMT", value: 1 },
        { label: "组装", value: 2 },
        { label: "机加", value: 3 },
        { label: "测试", value: 4 },
        { label: "包装", value: 5 },
        { label: "冲压", value: 6 },
      ],
      workshopStatusOptions: [
        { label: "筹建", value: 0 },
        { label: "正常", value: 1 },
        { label: "临时停产", value: 2 },
        { label: "永久停用", value: 3 },
      ],
      traceLevelOptions: [
        { label: "简易追溯", value: 1 },
        { label: "工单完整追溯", value: 2 },
        { label: "全参数采集追溯", value: 3 },
      ],
      cleanRoomLevelOptions: [
        { label: "百级", value: "百级" },
        { label: "千级", value: "千级" },
        { label: "万级", value: "万级" },
        { label: "十万级", value: "十万级" },
      ],
      workshop: {},
      ruleValidate: {
        workshopName: { required: true, message: "请输入车间全称", trigger: "blur" },
        factoryID: { required: true, message: "请选择所属工厂", trigger: "change" },
        workshopType: { required: true, message: "请选择车间类型", trigger: "change" },
        workshopStatus: { required: true, message: "请选择车间状态", trigger: "change" },
      },
    };
  },
  methods: {
    resetForm() {
      this.$refs.form && this.$refs.form.resetFields();
    },
    open(row) {
      this.dialogVisible = true;
      this.factoryName = row ? row.factoryName || "" : "";
      this.workshop = Object.assign(
        {
          id: undefined,
          factoryID: 0,
          workshopCode: "",
          workshopERPCode: "",
          workshopWMSCode: "",
          workshopWCSCode: "",
          workshopSCADACode: "",
          workshopName: "",
          workshopShortName: "",
          workshopEnglishName: "",
          workshopType: 1,
          workshopSubType: undefined,
          isTrialWorkshop: false,
          isOutsourceWorkshop: false,
          isCleanRoom: false,
          cleanRoomLevel: "",
          standardTemp: undefined,
          standardHumidity: undefined,
          dustControl: false,
          staticControl: false,
          totalArea: undefined,
          productionArea: undefined,
          storageArea: undefined,
          passageArea: undefined,
          equipmentArea: undefined,
          supervisorID: undefined,
          supervisorName: "",
          productionMgrID: undefined,
          productionMgrName: "",
          qualityMgrID: undefined,
          qualityMgrName: "",
          maintenanceMgrID: undefined,
          maintainerName: "",
          safetyMgrID: undefined,
          safetyMgrName: "",
          maxStaffCount: undefined,
          standardStaffCount: undefined,
          defaultShiftMode: 1,
          maxSupportShiftNum: 3,
          allowOvertime: false,
          standardDailyOutput: undefined,
          standardHourOutput: undefined,
          supportAGV: false,
          agvTrafficRule: 1,
          isClosedLogistics: false,
          hasLineSideWarehouse: false,
          isKeyWorkshop: false,
          needFirstArticleCheck: false,
          needIPQC: false,
          needOQC: false,
          traceLevel: 2,
          standardDailyPower: undefined,
          airConditionPower: undefined,
          workshopStatus: 1,
          officialOpenDate: "",
          stopProductionDate: "",
          remark: "",
          extendJson: "",
        },
        row || {}
      );
    },
    selectFactory(row) {
      this.workshop.factoryID = row.id;
      this.factoryName = row.factoryName;
    },
    submitHandle() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          this.$http
            .save("basic", "fm/workshop", this.workshop)
            .then((resp) => {
              this.submitLoading = false;
              if (resp.success) {
                this.$emit("save-success");
                this.$message.success(this.workshop.id ? "编辑成功" : "添加成功");
                this.dialogVisible = false;
              }
            })
            .catch(() => {
              this.submitLoading = false;
            });
        }
      });
    },
  },
};
</script>

<style scoped>
.fm-section-title {
  font-weight: bold;
  padding: 10px 0 5px;
  margin-bottom: 10px;
  border-bottom: 1px solid #e8e8e8;
  color: #409eff;
}
</style>
